import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../store';


@customElement('family-overview-head')
export class FamilyOverviewHead extends connect(store)(LitElement) {

	static styles = [
	css`
		:host {
			padding-bottom: 7mm;
			margin: 0;
		}

		.headline {
			container-type: inline-size;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			width: 100%;
			margin: 0;
			padding: 0;
		}

		.title {
			font: var(--font-specsheet-print-title-bold);
			font-size: 2.5cqw;
			color: var(--color-black);
			margin: 0;
			padding: 0;
			line-height: 1.2;
			letter-spacing: 1px;
			flex: 2;
		}

		.subtitle {
			text-transform: uppercase;
			color: var(--color-black);
			text-decoration: none;
			font: var(--font-specsheet-print-light);
			margin: 0;
			padding: 0;
		}

		.document-subtitle {
			font: var(--font-specsheet-print-light);
			color: var(--color-grey4);
			flex: 1;
			text-align: right;
			font-size: 1cqw;
		}

		a {
			color: var(--color-black);
			text-decoration: none;
		}

	`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}


	stateChanged(state) {
		this.productData = state.productData;
		this.status = state.status;
		this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';
		if (state.specsheet.data.specsheets && state.status.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
		}
	}


	render() {
		if (!this.kirbySpecsheet) return html``;

		return html`
			<div class="headline">

				<div class="flex-item title">
					<h2 class="title">
						${this.family}
					</h2>
					<h3 class="subtitle">
						${when(
							this.shortKey !== null,
							() => html`${msg('Configuration ID')}: <a href="${this.status.host}${this.status.baseUrl}${this.status.region}/${this.status.lang}/${this.status.family}/sections/${this.status.mode}/${this.status.shortKey}">${this.shortKey}</a>`,
						)}
						${when(
							this.shortNumberProductModel !== '',
							() => html`, ${msg('Article Nr.')}: <a href="${this.status.host}${this.status.baseUrl}${this.status.region}/${this.status.lang}/${this.status.family}/sections/${this.status.mode}/${this.status.shortKey}">${this.shortNumberProductModel}</a>`,
						)}
					</h3>
				</div>

				<div class="flex-item document-subtitle">
						${msg('Family')}
				</div>
			</div>
		`;
	}
}
